<template>
  <nav class="navbar navbar-toggleable-md navbar-inverse bg-darkgrey sticky-top box-shadow p-0">
    <button class="navbar-toggler navbar-toggler-right mt-1" type="button" data-toggle="collapse" data-target="#KeepNeyeNavbar">
      <span class="navbar-toggler-icon"></span>
    </button>
    <a class="navbar-brand" @click.prevent>
      <img src="../../../assets/KeepNeye.png" width="30" height="30" alt="">
    </a>
    <div class="collapse navbar-collapse" id="KeepNeyeNavbar">
      <ul class="navbar-nav mr-auto">
        <!-- <li class="nav-link">
          <span @click="$i18n.set('en')">EN</span>
        </li>
        <li class="nav-link">
          <span @click="$i18n.set('fr')">FR</span>
        </li> -->
        <li class="nav-item" :class="{'nav-select' : $route.name === 'Dashboard'}">
          <a class="nav-link" href="#/dashboard" @click="updateSeenUpdates()">{{$t('NavBar.dashboard')}}
          <i v-if="!updates" class="fas fa-circle notifier"></i></a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'OrderPending' || $route.name === 'OrderCurrent'}">
          <a class="nav-link" href="#/OrderCurrent">{{$t('NavBar.orders')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'TransferPending' || $route.name === 'TransferCurrent'}">
          <a class="nav-link" href="#/TransferCurrent">{{$t('NavBar.transfer')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'Zone'}">
          <a class="nav-link" href="#/Zone">{{$t('NavBar.zone')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'Search'}">
          <a class="nav-link" href="#/Search">{{$t('NavBar.search')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'AddressBook'}">
          <a class="nav-link" href="#/AddressBook">{{$t('NavBar.address_book')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'PendingAccounts'}">
          <a class="nav-link" href="#/PendingAccounts">{{$t('NavBar.pending_accounts')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'Users'}">
          <a class="nav-link" href="#/Users">{{$t('NavBar.users')}}</a>
        </li>

        <li v-if="isAdmin" class="nav-item" :class="{'nav-select' : $route.name === 'Logs'}">
          <a class="nav-link" href="#/Logs">{{$t('NavBar.logs')}}</a>
        </li>

        <li v-if="isAdmin" class="nav-item" :class="{'nav-select' : $route.name === 'Reports'}">
          <a class="nav-link" href="#/Reports">{{$t('NavBar.reports')}}</a>
        </li>

        <li class="nav-item" :class="{'nav-select' : $route.name === 'Settings'}">
          <a class="nav-link" href="#/Settings">{{$t('NavBar.settings')}}</a>
        </li>

        <li v-if="uid === '8650fc2a-b684-496d-92fc-85c73eced49a'" class="nav-item" :class="{'nav-select' : $route.name === 'Dev'}">
          <a class="nav-link" href="#/Dev">{{$t('NavBar.dev')}}</a>
        </li>
      </ul>
      <span>
        <a id="logout" class="nav-link navbar-text mx-3" href="#" @click.prevent="signOut()">{{$t('NavBar.logout')}}</a>
      </span>
    </div>
  </nav>
</template>

<script>
import Firebase from 'firebase'
import router from '../../../router'
import { db } from '../../../firebase.js'

export default {
  data () {
    return {
    }
  },
  props: {
    selected: {
      type: String,
      required: false,
      default: 'Dashboard'
    }
  },

  methods: {
    /** Update user data to:
     * Update seen in Firebase
     * Update seen in Store
     */
    updateSeenUpdates () {
      let updatedFields = {
        isUpdateSeen: true
      }
      db.ref('users/transportersman/' + this.uid).update(updatedFields)

      this.$store.state.authorization.isUpdateSeen = true
    },

    signOut () {
      Firebase.auth().signOut().then(() => {
        this.$store.commit('clearUser')
        this.$store.commit('clearContacts')
        this.$store.commit('CLEAR_SEARCH')
        router.push({path: '/login'})
      }).catch(function () {
      })
    }
  },

  computed: {
    isUserInfoLoaded () {
      return this.$store.state.userInfo
    },
    updates () {
      if (!this.isUserInfoLoaded) return
      if (this.$store.state.authorization.isUpdateSeen) return true
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    },
    uid () {
      return this.$store.state.user.uid
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  li, a.navbar-brand{
    margin-left: 1rem;
  }
  li.dropdown.nav-item{
    cursor: pointer;
  }
  .nav-select{
    border-bottom: 3px solid #f7941e;
  }
  @media (max-width: 991px) {
    nav{
      padding-bottom: .2rem !important;
    }
  }
  #logout{
    background-color: #ff5151;
    color: white;
    height: 100%;
  }
  .nav-link {
    position: relative;
  }
  .notifier {
    position: absolute;
    color: red;
    font-size: 0.4rem;
    top: 8px;
  }
  .navbar-nav {
    white-space: nowrap;
  }
  .navbar-toggler-icon {
    font-size: 1rem;
  }
</style>
